<script lang="ts">
  import { page } from "$app/stores";
  import { getI18nContext } from "$lib/i18n.svelte";
  import FeaturesSection from "@components/sections/FeaturesSection.svelte";
  import type { InstitutionCode } from "../../../../../popular";
  import type { PageData } from "./$types";
  import AppMeta from "@components/layout/AppMeta.svelte";
  import FaxUploadSection from "@components/sections/FaxUploadSection.svelte";
  import PricingSection from "@components/sections/PricingSection.svelte";
  import FaqSection from "@components/sections/FaqSection.svelte";

  const {
    data,
    params: { country, code },
  } = $page;

  const { number } = data as PageData;

  const i18n = getI18nContext();
  const t = i18n.t;

  const heading = t(`to.${code as InstitutionCode}.heading`, { ns: "popular" });
  const title = heading + ": " + number;
</script>

<AppMeta {title} />

<section
  class="relative flex hero before:bg-cover md:before:bg-90% lg:before:bg-70% before:bg-center md:before:bg-center-minus120px lg:before:bg-center"
>
  <div
    class="mx-auto px-4 lg:px-36 text-center mt-16 lg:mt-20 mb-12 lg:mb-24 z-10"
  >
    <h1
      class="font-semibold font-heading tracking-tighter text-gray-800 mb-4 md:text-6xl text-3xl"
    >
      {title}
    </h1>

    <h2 class="text-gray-700 md:text-2xl mb-12 pt-2">
      {t("subtitle", { ns: "index" })}
    </h2>

    <FaxUploadSection initialCountry={country} initialNumber={number} />
  </div>
</section>

<FeaturesSection />
<PricingSection />
<FaqSection onlyFeatured={true} />
